import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, notification } from "antd";
import auth from "../../services/auth";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  // Check localStorage for cooldown on mount

  // Back button with icon
  const navigate = useNavigate();
  useEffect(() => {
    const cooldown = localStorage.getItem("fp_cooldown");
    if (cooldown) {
      const expires = parseInt(cooldown, 10);
      const now = Date.now();
      if (expires > now) {
        setDisabled(true);
        setTimer(Math.ceil((expires - now) / 1000));
      }
    }
  }, []);

  // Timer countdown
  useEffect(() => {
    if (disabled && timer > 0) {
      const interval = setInterval(() => {
        setTimer((t) => {
          if (t <= 1) {
            setDisabled(false);
            localStorage.removeItem("fp_cooldown");
            clearInterval(interval);
            return 0;
          }
          return t - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [disabled, timer]);
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await auth.forgotPassword({ email: values.email });
      console.log(response);
      api.success({
        message: response.message || "Reset Link Sent",
        description:
          response.description ||
          `If an account exists for ${values.email}, a reset link has been sent.`,
      });
      // Set cooldown for 60 seconds
      const expires = Date.now() + 60000;
      localStorage.setItem("fp_cooldown", expires.toString());
      setDisabled(true);
      setTimer(60);
    } catch (error) {
      api.error({
        message: error?.message || "Error",
        description:
          error?.response?.data?.message || "Failed to send reset link.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {contextHolder}
      <Card
        title="Forgot Password"
        style={{ width: 400 }}
        styles={{ body: { paddingTop: 20 } }}
      >
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input placeholder="Enter your email" size="large" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              disabled={disabled}
            >
              {disabled ? `Wait ${timer}s` : "Send Reset Link"}
            </Button>
          </Form.Item>
        </Form>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          style={{ margin: "16px 0 0 -8px", paddingLeft: 0 }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Card>
    </div>
  );
};

export default ForgotPassword;
